import { RemoteGetAllGroupsNotPaginated } from 'data/usecases';
import { GetAllGroupsNotPaginatedUseCaseInterface } from 'domain/usecases';
import { makeApiUrlGroupList } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllGroupsNotPaginated =
  (): GetAllGroupsNotPaginatedUseCaseInterface =>
    new RemoteGetAllGroupsNotPaginated(
      makeApiUrlGroupList(),
      makeAxiosHttpClient(),
    );
